import userimg from '../../Assets/userimg.png';
export const data = [
    {
      id: 1,
      desc: "Virtuosoft's dedication and expertise have truly made a difference.Your innovative approach has provided a solid foundation for the success of the entire project.The streamlined procedure from ticket creation to completion reflects a commendable improvement, and I appreciate the establishment of a standard in this regard. Your insights and efforts in this area are crucial, and I thank you for your valuable contributions.",
      icon: (
        <img src={userimg} alt='client' style={{maxHeight:'100%',maxWidth:'100%',width:'56px',height:'56px',borderRadius:'50%'}}/>
      ),
      client: {
        name: "Geo Sunny, Engineering Lead",
        company: "ProdEngines Pvt Ltd",
        country: "India"
      }
    },
    {
      id: 2,
      desc: "MGP 2.0 is an intuitive and user-friendly application that significantly enhances the efficiency of branch operations. With this new system, branch staff can now complete gold purchase transactions in just 30 minutes—compared to the 2.5 to 3 hours required in the old system. Additionally, it has made opening new branches a seamless process.",
      icon: (
        <img src={userimg} alt='client' style={{maxHeight:'100%',maxWidth:'100%',width:'56px',height:'56px',borderRadius:'50%'}}/>
      ),
      client: {
        name: "Yash Panchal, Product Manager",
        company: "Muthoot Exim",
        country: "India"
      }

    }
  ];
  